import { FallbackProps } from 'react-error-boundary';
import React from 'react';
import { Button } from '@mui/material';
import styles from './ErrorFallback.module.css';

const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  return (
    <div className={styles.container}>
      <div> Sorry, something went wrong</div>
      {error?.message && <div>{error.message}</div>}
      <div>
        <Button onClick={resetErrorBoundary}>Take me back home</Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
